import {DialogStoreInterface} from "../DialogStore";
import {fmsDocumentPrinterStore, FmsPrinterItem, fmsVlogPrinterStore} from "./FmsPrinterStore";
import {userPrinterPreferenceStore} from "../ums";
import {makeAutoObservable, reaction} from "mobx";

class FmsModalDialogPrintStore implements DialogStoreInterface {
    get vlogPrinter(): FmsPrinterItem | undefined {
        return this._vlogPrinter;
    }

    set vlogPrinter(value: FmsPrinterItem | undefined) {
        this._vlogPrinter = value;
    }
    get documentPrinter(): FmsPrinterItem | undefined {
        return this._documentPrinter;
    }

    set documentPrinter(value: FmsPrinterItem | undefined) {
        this._documentPrinter = value;
    }

    get executing(): boolean {
        return this._executing
    }

    set executing(value: boolean) {
        this._executing = value
    }
    get dialogErrorMessage(): string | undefined {
        return this._dialogErrorMessage
    }

    set dialogErrorMessage(value: string | undefined) {
        this._dialogErrorMessage = value
    }
    get dialogOpen(): boolean {
        return this._dialogOpen
    }

    set dialogOpen(value: boolean) {
        this._dialogOpen = value
    }
    private _dialogOpen: boolean = false
    private _dialogErrorMessage?: string | undefined
    private _executing: boolean = false
    private _documentPrinter: FmsPrinterItem | undefined = undefined
    private _vlogPrinter: FmsPrinterItem | undefined = undefined

    constructor() {
        makeAutoObservable(this)
        reaction(() => [
            userPrinterPreferenceStore.documentPrinterId,
            userPrinterPreferenceStore.vlogPrinterId,
            fmsDocumentPrinterStore.options,
            fmsVlogPrinterStore.options,
        ], () => this.resetDefaultPrinter())
    }

    resetDefaultPrinter() {
        const {documentPrinterId, vlogPrinterId} = userPrinterPreferenceStore
        const documentOptions = fmsDocumentPrinterStore.options
        const vlogOptions = fmsVlogPrinterStore.options

        this.documentPrinter = documentOptions.find(p => p.id === documentPrinterId) || undefined
        this.vlogPrinter = vlogOptions.find(p => p.id === vlogPrinterId) || undefined
    }
}

export {
    FmsModalDialogPrintStore,
}
